import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useStorefrontContext } from 'context/StorefrontContext';
import { getSiteName } from 'config/appConfig';
import { resolveStoreMediaUrl } from 'utils/themeDisplay';
import { buildOrganizationJsonLd, buildWebSiteJsonLd } from 'utils/seo';

const TenantHead: React.FC = () => {
  const { theme } = useStorefrontContext();
  const siteName = theme?.siteName?.trim() || getSiteName();
  const faviconUrl = resolveStoreMediaUrl(theme?.faviconUrl);
  const organizationJsonLd = useMemo(() => JSON.stringify(buildOrganizationJsonLd(theme)), [theme]);
  const webSiteJsonLd = useMemo(() => JSON.stringify(buildWebSiteJsonLd(theme)), [theme]);
  return (
    <Helmet>
      <title>{siteName}</title>
      {faviconUrl && <link rel="icon" href={faviconUrl} />}
      <meta name="application-name" content={siteName} />
      <script type="application/ld+json">{organizationJsonLd}</script>
      <script type="application/ld+json">{webSiteJsonLd}</script>
    </Helmet>
  );
};

export default TenantHead;
